import React, { useState } from "react";
import Icone from "./Icone";

/**
 * Champ des écrans hors connexion : libellé, cadre .saisie, œil (toujours
 * présent sur un mot de passe, sur demande avec `revelable`), message d'erreur
 * ou de confirmation.
 * `aide` est un emplacement rendu entre le champ et les messages (jauge, règles…).
 * `enErreur` colore le champ en erreur sans message propre (le message est porté ailleurs).
 * Les autres props (autoComplete, inputMode, placeholder, autoFocus…) vont à l'<input>.
 */
const Saisie = ({
  id,
  label,
  type = "text",
  value,
  onChange,
  erreur = null,
  enErreur = false,
  ok = null,
  revelable = false,
  libelleRevelation = "le mot de passe",
  aide = null,
  ...inputProps
}) => {
  const [visible, setVisible] = useState(false);
  const avecOeil = revelable || type === "password";
  const typeEffectif = avecOeil ? (visible ? "text" : "password") : type;
  const idErreur = `${id}-erreur`;
  const classes = ["champ", erreur || enErreur ? "erreur" : "", ok && !erreur ? "ok" : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes}>
      <label htmlFor={id}>{label}</label>
      <div className="saisie">
        <input
          id={id}
          name={id}
          type={typeEffectif}
          value={value}
          onChange={onChange}
          aria-invalid={erreur || enErreur ? "true" : undefined}
          aria-describedby={erreur ? idErreur : undefined}
          {...inputProps}
        />
        {avecOeil && (
          <button
            type="button"
            className={"oeil" + (visible ? " actif" : "")}
            onClick={() => setVisible((v) => !v)}
            aria-label={`${visible ? "Masquer" : "Afficher"} ${libelleRevelation}`}
            aria-pressed={visible}
          >
            <Icone nom={visible ? "oeilBarre" : "oeil"} epaisseur={1.8} />
          </button>
        )}
      </div>
      {aide}
      {erreur && (
        <p className="aide-erreur" id={idErreur} role="alert">
          {erreur}
        </p>
      )}
      {ok && !erreur && <p className="aide-ok">{ok}</p>}
    </div>
  );
};

export default Saisie;
